<template lang="pug">
  ValidationObserver(ref="observerRef")
    form(novalidate)
      slot
</template>

<script>
import { useContext } from '@/compat';
import { ref } from 'vue';
import { ValidationObserver } from 'vee-validate';
import useAlert from '@/helpers/misc/dialog/useAlert';

export default {
  name: 'PhoValidationObserver',
  components: {
    ValidationObserver,
  },
  setup() {
    const { $i18n, $lang } = useContext();
    const alert = useAlert();
    const observerRef = ref(null);

    const alertingRules = ['waitUpload'];

    const showAlertingRules = () => {
      const failedRulesToAlert = Object.entries(observerRef.value.fields || []).reduce((acc, fields) => {
        const field = fields[1];
        const draftAcc = [...acc];

        if (field.invalid) {
          Object.entries(field.failedRules || []).forEach(([rule, message]) => {
            if (alertingRules.includes(rule)) {
              draftAcc.push(message);
            }
          });
        }

        return draftAcc;
      }, []);

      if (failedRulesToAlert.length > 0) {
        alert.warning($i18n.t($lang.app.WARNING), `<ul><li>${failedRulesToAlert.join('</li><li>')}</li></ul>`);
      }
    };

    const validate = async () => {
      const isValid = await observerRef.value.validate();

      if (!isValid) {
        showAlertingRules();
      }

      return isValid;
    };

    const reset = () => observerRef.value.reset();

    return {
      observerRef,
      showAlertingRules,
      validate,
      reset,
    };
  },
};
</script>
